import React from "react";
import "./MfaStatusCard.scss";
import Card from "../Card";

const MfaStatusCard = ({ contact }) => (
  <Card
    title="MFA"
    body={
      <div className="mfa-status-card">
        <div className="mfa-status-card__status">
          {contact.mfaEnabled ? "Enabled" : "Disabled"}
        </div>
      </div>
    }
  />
);

export default MfaStatusCard;